


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class TopicsView extends Vue {
  //管理サイトフラグ
  @Prop({default:false})public isAdmin:boolean;
  //登録モードフラグ
  @Prop({default:false})public isEditMode:boolean;

  public items: Common.Topics[] = new Array();
  public params: Common.TopicsQuery = new Common.TopicsQuery();
  public perm:string = null;

　public sortOptions: any = [
    { value: 'lastUpdatedOn', text: '更新日時' },
    { value: 'from', text: '送信者' },
    { value: 'State', text: '状態' },
  ];

  @Prop({default:null})public id:number;
  @Prop({default:null})public isAdminQuery:boolean;

　public created(){
    //お知らせ表示 or お知らせ登録をメニューで切り分け
    this.params.isEditMode = this.isEditMode;
    if (this.id) this.params.id = this.id;
    if (this.isAdminQuery != null) this.params.isAdmin = this.isAdminQuery;

    if (this.isAdmin) this.perm="operation";
    else if (this.isEditMode) this.perm="system.menu_topics_edit";

    //リスト登録(レコードがない場合)
    this.$api.formatter.suspendLoading();
    this.$api.formatter.ensureListLoaded('topicsGroup','group');

  }
　public async fromQuery():Promise<Common.BindItem[]> {
    if (this.isAdmin) {
      return Promise.resolve([new Common.BindItem('admin','サイト管理者')]);
    } else {
      return Promise.resolve(this.$api.formatter.getOptions('group'));
    }
  }
  public async toQuery():Promise<Common.BindItem[]> {
    if (this.isAdmin) {
      return Promise.resolve([new Common.BindItem('tenant','テナントユーザー')]);
    } else {
      return Promise.resolve(this.$api.formatter.getOptions('group'));
    }
  } 
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public targetFlag = Common.CampaignTenantFlags.default;
  public showDialog:boolean = false;
  public onSendTopic(){
    var items = (this.$refs.mainList as Components.ListView).selectedItems as Array<Common.Topics>;
    if (items.length !=1) {
      this.$api.modal.show("無効な操作","送信対象を1件選択してください。",true,null);
      return;
    }
    if (items[0].state != Common.ApprovalStatus.Approved) {
      this.$api.modal.show("無効な操作","公開済みのお知らせを選択してください。",true,null);
      return;
    }    
    this.targetFlag = Common.CampaignTenantFlags.default;
    this.showDialog = true;
  }

  public onExecute(event :any){
    const control = (this.$refs.targetFlag as any) as Components.IControl;
    if (control.validator.validate() == false) {
      event.cancel();
      return;
    }
    var target = this.$api.formatter.formatByList(this.targetFlag,"campaingTenantFlagsList");
    var item =  (this.$refs.mainList as Components.ListView).selectedItems[0];
    this.$api.modal.showDialog("処理確認",String.format("{0}テナント向けにメールを送信してよろしいですか？",target),false,"送信する","キャンセル")
    .then(()=> this.$api.execute(new Common.TopicsSendQuery(item,this.targetFlag)))
    .then(res =>{
      var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
      this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n処理結果は、通知のメール、または以下のリンクから確認できます。',true,null,links);      
    });

  }
}
